'use client';

import React from 'react';
import { LucideIcon } from 'lucide-react';
import styles from './ServiceCard.module.css';

interface ServiceCardProps {
    icon: LucideIcon;
    title: string;
    description: string;
    badge?: string;
    isActive?: boolean;
    onClick?: () => void;
}

export const ServiceCard = ({
    icon: Icon,
    title,
    description,
    badge,
    isActive,
    onClick,
}: ServiceCardProps) => {
    const cardClasses = [styles.card, isActive ? styles.active : ''].join(' ').trim();

    return (
        <div className={cardClasses} onClick={onClick}>
            <div className={styles.contentWrapper}>
                {/* Обертка для иконки */}
                <div className={styles.iconWrapper}>
                    <Icon className={styles.icon} />
                </div>

                {/* Текстовый контент */}
                <div className={styles.textWrapper}>
                    <div className={styles.header}>
                        <h3 className={styles.title}>{title}</h3>
                        {badge && <span className={styles.badge}>{badge}</span>}
                    </div>
                    <p className={styles.description}>{description}</p>
                </div>
            </div>

            <div className={styles.activeBorder}></div>
        </div>
    );
};
